import { render, staticRenderFns } from "./IncidentList.vue?vue&type=template&id=4fab0d94&"
import script from "./IncidentList.vue?vue&type=script&lang=ts&"
export * from "./IncidentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports